<template>
    <header>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4 col-sm-8">
                    <button @click="$router.back()" class="btn-back" type="button">
                        <img src="/img/icon01.svg" alt=""/>
                    </button>
                    <div class="small-txt text-uppercase">{{i18n('Reys on')}} {{selectedDate}}</div>
                    <div class="big-txt">{{searchFrom.name}} — {{searchTo.name}}</div>
                </div>
                <div class="col-sm-4 text-center d-sm-none d-md-block">
                    <img src="/images/2020.png" alt="2020" id="ny2020">
                </div>
                <div class="col-sm-4 text-right">
                    <div class="small-txt">{{today}}</div>
                    <div class="big-txt">{{currentTime}}</div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "PagesHeader",
        props: {
            day: {
                type: String,
            },
            routeName: {
                type: String,
            },
            selected: {
                type: Number
            }
        },
        data() {
            return {
                today: this.$moment().format('YYYY-MM-DD'),
                currentTime: this.$moment().format('HH:mm:ss'),
                searchFrom: null,
                searchTo: null,
                searchDate: null,
            }
        },
        created() {
            this.searchFrom = JSON.parse(localStorage.getItem('searchFrom'));
            this.searchTo = JSON.parse(localStorage.getItem('searchTo'));
            this.searchDate = JSON.parse(localStorage.getItem('searchDate'));
            setInterval(() => {
                this.setTime()
            }, 1000);
        },
        methods: {
            setTime() {
                this.currentTime = this.$moment().format('HH:mm:ss');
                this.today = this.$moment().format('YYYY-MM-DD');
            }
        },
        computed:{
            selectedDate(){
                let addDay = this.$store.state.addDay || 0;
                return this.$moment(this.$store.state.date.date).add(addDay,'days').format('D MMMM');
            }
        }
    }
</script>

<style scoped>
    #ny2020 {
        height: 66px;
    }
    @media (max-width: 992px) {
        #ny2020 {
            display: none;
        }
    }
</style>
